module.exports = __webpack_public_path__ + "static/img/box-close.c1166073.png";